import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/edit-page";
import {Page} from "../bo/page";
import jQuery from "jquery";
import {TemplateEditor} from "./template_editor";
import Alerts from "../misc/alerts";
import {formToJson, replaceHash} from "../misc/utils";
import {EditPageNotification, EditWebsiteNotification} from "./wrb";
import {Website} from "../bo/website";

const classname = "edit-page-view";

function nameToPath(name: string | undefined) {
    name = name || "";
    return encodeURIComponent(name.toLowerCase().trim().replace(/ /g, "-"));
}

export class EditPageView extends View {

    private readonly server = Server.instance();

    private path: string;

    private website?: Website;

    private page?: Page;

    private editor: TemplateEditor;

    private trackName = true;

    constructor(path: string) {
        super(classname);
        this.path = path;
        this.editor = new TemplateEditor(this.path);
        this.load();
    }

    async load() {
        this.website = await this.server.website();
        const pages = this.website.pages || [];
        this.page = pages.filter(p => p.path == this.path)[0];
        this.trackName = this.page.path == nameToPath(this.page.name);
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        if (! this.page) {
            return jQuery("<div>");
        }

        const data = {
            page: this.page,
            editor: this.editor
        };

        return this.pug(template, data);
    }

    async delete() {
        const YES_DELETE = "Yes, really delete";
        const NO = "No, don't delete";

        const confirm = await Alerts.confirmation({
            options: [ YES_DELETE, NO ],
            message: "Really delete page?"
        });

        if (confirm == YES_DELETE) {
            const w = await this.server.website();
            const ps = w.pages as Page[];
            const p2: Page[] = [];
            for (const p of ps) {
                if (p.path != this.path) {
                    p2.push(p);
                }
            }
            w.pages = p2;
            await this.server.saveWebsite(w);
            this.notify(new EditWebsiteNotification());
        }
    }

    async save() {
        const form = this.elt().find("form");
        const data : any = {};
        formToJson(form, data);

        const g = this.editor.toTemplate();
        await this.server.saveTemplate(this.path.split(/\\/), g);
        console.log("Saved template", g);

        await this.load();

        if (this.page && this.website) {
            this.page.name = data.name as string;
            this.page.path = data.path as string;
            this.page.enabled = data.enabled ? true : false;
            await this.server.saveWebsite(this.website);
            this.notify(new EditPageNotification(this.page.path));
        }
    }

    onNameChange() {
        if (! this.trackName) {
            return;
        }
        const name = this.elt().find("input[name=name]").val() as string;
        this.elt().find("input[name=path]").val(nameToPath(name));
    }

    onPathChange() {
        if (! this.trackName) {
            return;
        }
        const name = this.elt().find("input[name=name]").val() as string;
        const path = this.elt().find("input[name=path]").val() as string;
        if (nameToPath(name) != path) {
            this.trackName = false;
        }
    }
}

View.on(
    "." + classname,
    "input",
    "input[name=name]",
    function(that: EditPageView, event, elt) {
        event.preventDefault();
        that.onNameChange();
    });

View.on(
    "." + classname,
    "input",
    "input[name=path]",
    function(that: EditPageView, event, elt) {
        event.preventDefault();
        that.onPathChange();
    });


View.on(
    "." + classname,
    "click",
    ".save",
    function(that: EditPageView, event, elt) {
        event.preventDefault();
        that.save();
    });

View.on(
    "." + classname,
    "click",
    ".delete",
    function(that: EditPageView, event, elt) {
        event.preventDefault();
        that.delete();
    });
